export default __webpack_public_path__ + "static/media/welcome.852f4d21.svg";